import { useState } from 'react';
import OpenAI from 'openai'

const key = process.env.REACT_APP_OPEN_AI_API_KEY

const openai = new OpenAI({
    dangerouslyAllowBrowser: true,
    apiKey: key,
})

const ImageGeneration = () => {

    const [prompt, setPrompt] = useState('');
    const [imageSrc, setImageSrc] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        generateImage(prompt);
    };

    const generateImage = async (prompt) => {
        if (!prompt) {
            alert('Please enter a prompt');
            return;
        }
        try {
            setLoading(true);
            const response = await openai.images.generate({
                model: 'dall-e-3', // default dall-e-2
                prompt: prompt, //required
                n: 1, //default 1 // n is the number of images , with dalle3 we can only have 1 in dalle2 we can have different 
                size: '1024x1024', //default 1024x1024
                style: 'vivid', //default vivid (other option: natural)
                response_format: 'b64_json' //default url
            })
            setImageSrc(response.data[0].b64_json);
            setLoading(false);
        } catch (error) {
            console.error('Error generating image:', error);
            setLoading(false);
            alert('Error generating image. Please try again.');
        }
    }

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <div className="bg-white shadow-md rounded-lg p-6 max-w-md w-full">
                <h1>ArtMatch 👩‍🎨</h1>
                {/* <div id="output-img" className="frame">
                    <h2>Describe a famous painting without saying its name or the artist!</h2>
                </div> */}
                <input
                    type="text"
                    id="instruction"
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    placeholder="Enter prompt"
                />
                <button id="submit-btn" onClick={handleSubmit}>
                    Generate
                </button>
                {imageSrc && !loading && <img id="output-img" src={`data:image/png;base64,${imageSrc}`} alt="Generated result" />}
                {loading && <p>Loading...</p>}

            </div>
        </div>
    )

}

export default ImageGeneration;